export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    tiva_abrev: item.tiva_abrev || "Abreviatura no disponible",
    tiva_descripcion: item.tiva_descripcion || "Descripción no disponible",
    tiva_afip_codigo: item.tiva_afip_codigo || "Código AFIP no disponible",
    tiva_fiscal_codigo: item.tiva_fiscal_codigo || "Código fiscal no disponible",
  }));
